import axios from 'axios';
import Env from '~/credsystem/env';
import { CredsystemLocalStorage } from '~/credsystem/storage/LocalStorage';
import { CREDSYSTEM_LOGIN_TOKEN } from '~/credsystem/storage/constants';

interface GetCredSystemInfoUserParams {
  document: string;
}

export async function getCredSystemInfoUserUseCase({
  document,
}: GetCredSystemInfoUserParams): Promise<boolean | null> {
  try {
    const token = await CredsystemLocalStorage.get(CREDSYSTEM_LOGIN_TOKEN);

    if (!token) {
      return null;
    }

    const response = await axios.get(
      `https://${Env.CREDSYSTEM_CLIENT_SESSION_API}/api/v1/usuario/sso/info/${document}`,
      {
        headers: { APP: 'APP_MARISA', Authorization: `Bearer ${token}` },
      }
    );

    if (response.data?.data?.exist) {
      return true;
    }

    return false;
  } catch (error) {
    return null;
  }
}
